import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import {Collection, CollectionData} from "types/Collection";
import deserializeCollection from "services/ngage/deserializers/collection";
import {snakeKeys} from "../array";

export type CollectionFilters = {
    page?: number
    per_page?: number
    sites?: string
}

/**
 * Get all collections (paginated)
 */
const all = async (filters?: CollectionFilters) => {
    const params = Object.assign({page: 1, per_page: 100}, snakeKeys(filters ?? {}))
    const response = await client.get<DataPage<Collection>>(`/collections`, {params})

    if(response.data){
        response.data.data = response.data.data.map(deserializeCollection)
    }

    return response.data
}

/**
 * Get a single collection
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<Collection>(`/collections/${id}`)
    return deserializeCollection(response.data)
}

/**
 * Store a new collection
 *
 * @param data
 */
const store = async (data: CollectionData) => {
    const response = await client.post<Collection>('/collections', data)
    return deserializeCollection(response.data)
}

/**
 * Update an existing collection
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: CollectionData) => {
    const response = await client.put<Collection>(`/collections/${id}`, data)
    return deserializeCollection(response.data)
}

/**
 * Permanently delete a collection
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/collections/${id}`)
    return response.status === 204
}

const collections = {
    all,
    get,
    store,
    update,
    destroy
}

export default collections;